<template>
  <div class="flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-buy">
    <div class="vx-col w-full sm:w-2/3 md:w-2/3 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg">
              <div class="p-6">

                <div class="vx-card__title mb-4 text-center">
                  <img src="@/assets/images/pages/whatsapp_logo_1.svg" class="mx-auto mb-2 w-24 h-24">
                  <h4 class="mb-4">Send a message to <strong class="text-primary">{{this.$store.state.form.current_published_form.organization[0][0].name}}</strong><br>via WhatsApp</h4>
                  <small>QuickSend is a Whatsapp based platforms and has no official affliation with Whatsapp Inc.</small>
                </div>

                <div>
                   <gridProduct/>       
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>


import vSelect from 'vue-select'
import router from '@/router';
import axios from '@/axios';
import gridProduct from './landingGridComponent';

const dialogs = {
  invalidForm: (error) => {
    return {
      color: "danger", 
      title: "Invalid Form Specified",
      text: "Sorry, we cannot find the form you want to edit.",
      accept: () => {
        router.push('/forms');
      },
      close: () => {
        router.push('/forms');
      }
    }
  }, 

  saveFormFailed: (error) => {
    if (_.isEmpty(error)) error = "Sorry, we cannot save the form";

    return {
      color: "danger", 
      title: "Cannot Save Form",
      text: error,
      accept: () => {
        console.dir(error); // intentional for debug
      }
    }
  },

  incompleteAssets: (msg) => {
    return {
      color: "danger", 
      title: "Cannot Find Page You Looking For",
      text: msg,
      accept: () => {
        router.push('/forms');
      },
      close: () => {
        router.push('/forms');
      }
    }
  }
}

export default {
  components: {
      vSelect,
      gridProduct
  },
  data(){
    return {
      name: "",
      phone: "",
      productAmount: 0,
      productMethod: { label: 'Choose your product', value: '' },
      productOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ],
      phoneNumber:"",
      buyerName:"",
      companyName:"",
    }
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          alert("form submitted!");
          //this.$router.push({ name: 'buyer-checkout' })
          this.$router.push({ name: 'buyer-cart' })
        } else {
          // form have errors
        }
      })
    }, 
    orderNow() {
      //I put this method here so that for existing order can be used to update rather than insert
          console.log(this.buyerName);
          console.log(this.phoneNumber);
          console.log(this.$route.params.formid);
          console.log(this.products.productvariant);
    },
  },
  async mounted (){
    
    if(this.$route.params.formid!==undefined)
    {
      try {
        await this.$store.dispatch('form/getSinglePublishedForm', this.$route.params.formid);
      } catch (e) {
        this.$vs.dialog(dialogs.incompleteAssets(e.data.message));
        return;
      }
    }
    else if(this.$route.params.branded!==undefined){
     
     var subdomain;
      if(this.$store.state.subdomain===undefined || this.$store.state.subdomain===''){subdomain='';}
      else{ subdomain=this.$store.state.subdomain;}

      try {
        await this.$store.dispatch('form/getSinglePublishedBrandedForm', {'branded':this.$route.params.branded, 'subdomain':subdomain});
      } catch (e) {
        this.$vs.dialog(dialogs.incompleteAssets(e.data.message));
        return;
      }

    }
    else{
      try {
        await this.$store.dispatch('form/getSinglePublishedFormOrder', this.$route.params.orderid);
      } catch (e) {
        this.$vs.dialog(dialogs.incompleteAssets(e.data.message));
        return;
      }
    }

  }

}
</script>
